import { RouterProvider } from '@tanstack/react-router';
import { ThemeProvider } from '@/shell/theme/theme-provider';
import { ToastProvider } from '@/shell/ui/toast';
import type { AppRouter } from './router';
import { type SessionOptions, SessionOptionsContext } from './session-options';

/**
 * Wurzel der Anwendung: Farbvariante, Rückmeldungen (Toast), Sitzungseinstellungen und Router. Die Sitzung selbst
 * sitzt in der Wurzelroute (dort ist der Router bekannt: Weiterleitung zu „Kein Zugang“, interne Links).
 */
export function App({ router, session = {} }: { router: AppRouter; session?: SessionOptions }) {
  return (
    <ThemeProvider>
      <ToastProvider>
        <SessionOptionsContext.Provider value={session}>
          <RouterProvider router={router} />
        </SessionOptionsContext.Provider>
      </ToastProvider>
    </ThemeProvider>
  );
}
